import { svg } from 'lit';

const symbol = svg`<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 14L9 9L4 4" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
<path d="M11 14L16 9L11 4" stroke="white" stroke-width="0.5" stroke-linecap="square" stroke-linejoin="round"/>
</svg>`;

export { symbol as default };

